import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { H2 } from "../../../AbstractElements";
import { CommonFormPropsType } from "../../../Types/LoginForm";

const CommonLogo = ({ alignLogo }: CommonFormPropsType) => {
  return (
    <Link
      className={`logo ${alignLogo ? alignLogo : ""}`}
      to={`/payment-management`}
    >
      <Row className="d-flex justify-content-center align-items-center text-center">
        {/* <Col>
          <Image
            className="img-fluid for-light"
            src={dynamicImage("logo/logo.png")}
            alt="loginpage"
          />
          <Image
            className="img-fluid for-dark"
            src={dynamicImage("logo/logo_dark.png")}
            alt="loginpage"
          />
        </Col> */}
        <Col>
          <H2>IMS Dashboard</H2>
        </Col>
      </Row>
    </Link>
  );
};

export default CommonLogo;
